import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import copy from 'copy-to-clipboard'

import { toaster, SelectMenu, Button, Position } from 'evergreen-ui'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMapMarkerAlt,
  faArrowAltCircleRight,
  faTruck,
  faPersonBooth,
  faCheckSquare,
  faSearch,
  faExclamationCircle,
  faClock,
  faExclamationTriangle,
  faHourglassHalf,
  faStoreAlt,
  faBoxOpen,
  faCircleNotch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { apiService, translateService } from '../services'
import TimeLine from './TimeLine'


import {
  changeTranslationSelectorState,
  changeTranslationTargetLanguage,
} from '../redux/Tracefully/AppSettings'

const mapDispatchToProps = function mapDispatch(dispatch) {
  return bindActionCreators({
    changeTranslationSelectorState: changeTranslationSelectorState,
    changeTranslationTargetLanguage: changeTranslationTargetLanguage,
  }, dispatch)
}
const mapStateToProps = function mapState(state) {
  return {
    AppSettings: state.AppSettings,
    UserSettings: state.UserSettings,
  }
}

class TrackItem extends Component {


  constructor(props) {
    super(props)


    this.state = {}
  }

  componentDidMount() {
  }


  render() {

    return (

        <div className="trackitem" id={this.props.trackingNr} key={this.props.trackingNr}>

          <div
              role="button"
              data-w-id="fe6c57d1-f97e-b1d1-33c8-02e438ee9403"
              id="trackitembody"
              onClick={(e) => this.Extend(e)}
              className={
                ((this.state.extended || this.props.expanded) && this.state.canExtend) ? 'trackitembody trackitemexpanded' : 'trackitembody'
              }>
            <div className="w-layout-grid grid-3">
              <div className="itemstatuscontainer">
                <div className="shippingstateiconcontainer stateIcon-Ghost">
                  <div className="shippingstateicon">
                    <FontAwesomeIcon
                        className='fa-spin'
                        style={{width: '26px', height: '26px', color: '#007DF6'}}
                        icon={faCircleNotch}/>
                  </div>
                </div>
                <div className="trackinginfo">
                  <div className="div-block-196">
                    <div role="button" className="trackingnrtext"
                         onClick={(e) => this.copyTrackingnr(e, this.props.trackingNr)}>{this.props.trackingNr}
                    </div>
                  </div>
                  <div className="div-block-195">
                    <div className="trackingstatetext">LOADING</div>
                  </div>
                </div>
              </div>


              <div className="trackinfocontainer">


              </div>

            </div>
          </div>


        </div>
    )
  }
}


export default TrackItem
